import { IconEdit } from 'featherico';
import * as React from 'react';
import MiniUser from '../../../../../../types/MiniUser';
import LinkButton from '../../../../components/LinkButton';
import { getCurrentUser } from '../../../../services/CurrentUser';
import { isReviewee, isSelfInvolved, isUserContributingReviewer } from '../../services/review';
import { getEditUrl } from '../../services/url';
import { getEditLabel } from '../../services/wording';
import { AssessmentStatus, Review, ReviewStatus } from '../../types';

// We need to support both status types for now…
type HybridStatus = ReviewStatus | AssessmentStatus;

interface Props extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
    review: Review;
    revieweeStatus: HybridStatus;
    mainReviewerStatus: HybridStatus;
}

export default function EditLink({ review, revieweeStatus, mainReviewerStatus, ...otherProps }: Props) {
    const currentUser = getCurrentUser();
    const isReadonly =
        (!review.permissions.canWrite && !review.permissions.canEditOverallRating) ||
        revieweeStatus === ReviewStatus.SIGNED ||
        revieweeStatus === AssessmentStatus.SIGNED ||
        mainReviewerStatus === AssessmentStatus.SIGNED ||
        !isSelfInvolved(currentUser, review);
    if (isReadonly) {
        return null;
    }
    const isContributingReviewer = isUserContributingReviewer(currentUser, review);
    const status = getStatusForUser(currentUser, review, revieweeStatus, mainReviewerStatus);
    const label = isContributingReviewer
        ? 'Contribute'
        : getEditLabel(status, currentUser.id, currentUser, review.useIndividualAssessments);
    return (
        <LinkButton href={getEditUrl(review.id)} kind="PRIMARY" {...otherProps}>
            <IconEdit /> {label}
        </LinkButton>
    );
}

function getStatusForUser(
    user: MiniUser,
    review: Review,
    revieweeStatus: HybridStatus,
    mainReviewerStatus: HybridStatus
) {
    const isUserReviewee = isReviewee(user, review);
    if (isUserReviewee) {
        return revieweeStatus;
    }
    const isReviewer = review.mainReviewer && review.mainReviewer.id === user.id;
    if (isReviewer || !review.useIndividualAssessments) {
        return mainReviewerStatus;
    }
    // TODO: Handle secondary/contributing Reviewers, probably via review.contributingReviewers!
    return null;
}
